$(document).ready(function() {
window.addEventListener("load", startObserver);
const stickyBar = document.querySelector(".cstm_sticky_atc");
const target = document.querySelector(".product-grid__container block-buy-buttons");

console.log(target);
console.log(target.outerHTML);
if (!stickyBar || !target) return;

let observerStarted = false;
let isHidden = false;

function startObserver() {
    if (observerStarted) return;
    observerStarted = true;

    const observer = new IntersectionObserver((entries) => {

        if (!entries.length) return;

        const entry = entries[0];

        // Viewport me aa gaya
        if (entry.isIntersecting) {
            if (!isHidden) {
                isHidden = true;
                stickyBar.style.display = "none";
            }
        }
        // Viewport se bahar chala gaya
        else {
            if (isHidden) {
                isHidden = false;
                stickyBar.style.display = "";
            }
        }

    }, {
        threshold: 0.1
    });

    observer.observe(target);
}



window.addEventListener("scroll", startObserver, {
    once: true,
    passive: true
});

   setTimeout(()=>{
         var variantId = $('.block-buy-buttons:not(.sticky_atc)')
        .find('input[name="id"]')
        .val();

        console.log(variantId);
        $('.sticky_variant').hide();

      // Jiska var_id match kare usko show
      $('.sticky_variant').filter(function () {
          return $(this).attr('var_id') == variantId;
      }).show();

   $(".cstm_sticky_atc").find('input[name="id"]')
        .val(variantId);
    },1000)
  $('.variant__button-label').click(function(){
    var $this = $(this);
    if($this.hasClass("disabled")){
      setTimeout(function(){
        $("form button.add-to-cart.element-button").attr("disabled", "disabled");
        $("form button.add-to-cart.element-button span").text("Sold Out");
        $("#block_buy_now").attr("disabled", "disabled");
        console.log("enter sold out");
      }, 500); 
    }else{
      $("#block_buy_now").removeAttr("disabled");
    }
  });
 /********************* Variant selection on product start *********************/
 $('.variant-input').each(function() {
  if ($(this).find('.variant_free_content_wrap').length) {
    $(this).addClass('variant-content');
  }
  if ($(this).find('input:checked').length) {
    $(this).addClass('variant-input-checked');
   var disabledBtn = $(this).find(".variant__button-label").hasClass("disabled");
    if(disabledBtn){
      $("form button.add-to-cart.element-button").attr("disabled", "disabled");
        $("form button.add-to-cart.element-button span").text("Sold Out");
        $("#block_buy_now").attr("disabled", "disabled");
    }
  }
});

  $('.variant-input').on('change', 'input', function() {
    setTimeout(()=>{
         var variantId = $('.block-buy-buttons:not(.sticky_atc)')
        .find('input[name="id"]')
        .val();

        console.log(variantId);
        $('.sticky_variant').hide();

      // Jiska var_id match kare usko show
      $('.sticky_variant').filter(function () {
          return $(this).attr('var_id') == variantId;
      }).show();

      $(".cstm_sticky_atc").find('input[name="id"]')
      .val(variantId);
    },1200)
   
  var parent = $(this).closest('.variant-input');
  $(".variant-input").removeClass('variant-input-checked');
  if (parent.find('.variant_free_content_wrap').length) {
    parent.addClass('variant-content');
  }
  if (parent.find('input:checked').length) {
    parent.addClass('variant-input-checked');
  }
});
 /********************* Variant selection on product end *********************/

/********************* Variant selection on product Grid *********************/
  $(document).on('click','.scrollableList_top', function () {
        $(this).next('ul').slideToggle(200);
        $('.scrollableList_top').not(this).next('ul').hide();
  });

  $(document).on('click','.scrollableList ul li', function () {
      var selectedLI = $(this).html();
      console.log(selectedLI);
      var availability = $(this).attr('data-availability');
      var MainP=$(this).attr('data-price');
      var MainPw=$(this).attr('data-price-w') ;
      var CompareP=$(this).attr('data-compare');
      var ComparePw=$(this).attr('data-compare-w');  
  $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--current span.money').html(MainP).attr('data-currency-inr',MainP);
  if(CompareP != ''){
    if($(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original span.money').length ==0){
      $(this).parents('.grid-item__content').find('.grid-product__price').append('<span class="grid-product__price--original element-text--heading-xs element-text element-text--line-through"><span class="money" data-currency-inr=""></span></span>')
     }

    $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original .mrp-text').hide();
    $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original').show();
    $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original span.money').html("Rs"+CompareP).attr('data-currency-inr',CompareP).show();

    var savePrice = Math.floor(((ComparePw - MainPw)*100)/ComparePw); 
    if($(this).parents('.grid-item__content').find('.grid-product__price--savings').length ==0){
      $(this).parents('.grid-item__content').find('.grid-product__price').append('<span class="grid-product__price--savings element-text element-text--body-sm" style="color: var(--color-text-savings);"></span>');
    }

    $(this).parents('.grid-item__content').find('.grid-product__price--savings').html(`Save ${savePrice}%`).show();

   }else{
    $(this).parents('.grid-item__content').find('.grid-product__price--savings').hide();
    $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original').hide();
   }

  if(availability == 'false'){
    $(this).parents('.grid-item__content').find('.button_cart').text('Sold out').attr('disabled',true);
  }else{
    $(this).parents('.grid-item__content').find('.button_cart').text('Add To Cart').attr('disabled',false);
  }
  $(this).parents('.scrollableList').find('.selectedOption').html(selectedLI);
  $(this).parent('ul').hide();
    var selected_value= $(this).attr('data-value');
    $(this).parents('.grid-item__content').find('.button_cart').attr('data-id',selected_value); 
  });
  $('.scrollableList').show();
  $('.select__select').hide();

$(document).on("click", "ul.product-option-ul .init , .dropdown-icon", function() {
  $(this).closest("ul").find('.innerLi').toggle();
});
/************************ Variant selection on product Grid END ******************************/

/***************** Start Mobile accordian *****************/
$(".accordion_head").click(function () {
    if ($('.accordion_body').is(':visible')) {
        $(".accordion_body").slideUp(300);
        $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
        $(this).next(".accordion_body").slideUp(300);
        $(this).children(".plusminus").text('+');
    } else {
        $(this).next(".accordion_body").slideDown(300);
        $(this).children(".plusminus").text('-');
    }
});
/***************** End Mobile accordian *****************/
/***************** Start FAQ *****************/
 $(".accordion-content").css("display", "none");

  $(".accordion-content").first().css("display", "block").prev().addClass("open");
  $(".js-accordion-title").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
   
/***************** End FAQ *****************/

/***************** Product card add to cart start *****************/
$(document).on("click",".button_cart",function()  {
 
  if($(this).attr('disabled') != 'disabled'){
   $(this).html("Added!");
    var this1 = $(this);
    var dataId = $(this).attr("data-id"); 
    myFun(dataId,this1);
  }   
});  
function myFun(vid, this1) {
  alert("here add to cart");
  var dataStore = { 
    "id": vid, 
    "quantity": 1,
    "sections": "cart-ajax" 
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: dataStore,
    dataType: 'json',
    success: function(productResponse) {
      $(".button_cart").html("Add To Cart");
      // Dispatch event same structure me jaisa theme expect karta hai
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: {
          product: productResponse
        }
      }));
    },
    error: function(response) {
      var error_message = response.responseJSON.description;
      $(".button_cart").html("Add To Cart");
      $(`<p class="errors">${error_message}</p>`).insertAfter(this1);
      setTimeout(function() { this1.next('.errors').remove(); }, 5000);
    }
  });
}
 /***************** Product card add to cart end *****************/

/***************** Footer seo start *****************/
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.readmore');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
  var descriptionShort1 = document.querySelector('.readmore');
  descriptionShort1.style.display = 'block';
});
/***************** Footer seo end *****************/
});



/***************** Start Cart Popup *****************/
const DEBUG = true;

function showVariantPopup(e, productId) {
  if (e) { 
    e.preventDefault(); 
    e.stopPropagation(); 
  }
  document.querySelectorAll('.variant-popup').forEach((p) => (p.style.display = 'none'));
  const popup = document.getElementById(`variant-popup-${productId}`);
  if (popup) {
    document.body.appendChild(popup);
    popup.style.display = 'flex';
    resetPopupState(popup);
  }
}
function closeVariantPopupManual(buttonElement, e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation(); 
  }
  const popup = buttonElement.closest('.variant-popup');
  if (popup) {
    popup.style.display = 'none';
    const drawerOpen = document.querySelector('.js-drawer-open, .is-active, .cart-drawer--open');
    if (!drawerOpen) {
      document.body.style.setProperty("overflow", "auto", "important");
    }
  }
}

function resetPopupState(popupElement) {
  if (!popupElement) return;
  popupElement.querySelectorAll('.add-btn').forEach((btn) => { btn.style.display = 'block'; });
  popupElement.querySelectorAll('.qty-selector').forEach((sel) => {
    sel.style.display = 'none';
    const input = sel.querySelector('.qty-input');
    if(input.tagName === 'INPUT') input.value = '1'; else input.textContent = '1';
  });
  updateTotal(popupElement);
}

function updateTotal(popupElement) {
  if (!popupElement) return;
  const container = popupElement.querySelector('.variant-details');
  const totalDisplay = popupElement.querySelector('.total-row strong');
  const confirmBtn = popupElement.querySelector('.confirm-btn');
  const popupFooter = popupElement.querySelector(".popup-footer");

  let total = 0; 
  let totalCount = 0;

  if (container) {
    container.querySelectorAll('.variant-option').forEach((opt) => {
      const qtySelector = opt.querySelector('.qty-selector');
      if (qtySelector && qtySelector.style.display !== 'none') {
        const input = qtySelector.querySelector('.qty-input');
        const qty = parseInt(input.value || input.textContent) || 0;
        total += Number(opt.dataset.price) * qty;
        totalCount += qty;
      }
    });
  }

  if (totalDisplay) {
    totalDisplay.textContent = totalCount > 0 ? `Rs ${total.toLocaleString()}` : 'Rs 0';
  }
  
  if (confirmBtn) confirmBtn.disabled = totalCount === 0;

  if (popupFooter) {
    if (totalCount > 0) {
      popupFooter.classList.add("active-footer");
    } else {
      popupFooter.classList.remove("active-footer");
    }
  }
}

function handlePopupClicks(e) {
  const target = e.target;
  const popup = target.closest('.variant-popup');
  if (!popup) return;

  e.stopPropagation();

  if (target.closest('.add-btn[data-action="add-initial"]')) {
    e.preventDefault(); e.stopImmediatePropagation();
    const btn = target.closest('.add-btn');
    const parent = btn.closest('.variant-actions') || btn.closest('.variant-option');
    btn.style.display = 'none';
    const selector = parent.querySelector('.qty-selector');
    if (selector) {
      selector.style.display = 'flex';
      const input = selector.querySelector('.qty-input');
      if(input.tagName === 'INPUT') input.value = '1'; else input.textContent = '1';
    }
    updateTotal(popup);
    return;
  }

  if (target.matches('.qty-btn.plus')) {
    e.preventDefault(); e.stopImmediatePropagation();
    const input = target.previousElementSibling;
    let currentVal = parseInt(input.value || input.textContent) || 0;
    const newVal = currentVal + 1;
    if(input.tagName === 'INPUT') input.value = newVal; else input.textContent = newVal;
    updateTotal(popup);
    return;
  }

  if (target.matches('.qty-btn.minus')) {
    e.preventDefault(); e.stopImmediatePropagation();
    const input = target.nextElementSibling;
    let currentVal = parseInt(input.value || input.textContent) || 0;
    if (currentVal > 1) {
      const newVal = currentVal - 1;
      if(input.tagName === 'INPUT') input.value = newVal; else input.textContent = newVal;
    } else {
      const parent = target.closest('.variant-actions') || target.closest('.variant-option');
      parent.querySelector('.qty-selector').style.display = 'none';
      parent.querySelector('.add-btn').style.display = 'block';
      if(input.tagName === 'INPUT') input.value = '1'; else input.textContent = '1';
    }
    updateTotal(popup);
    return;
  }

  const footerCTA = target.closest('.popup-footer.active-footer');
  if (footerCTA) {
    e.preventDefault(); e.stopImmediatePropagation();
    const confirmBtn = footerCTA.querySelector('.confirm-btn');
    if (confirmBtn.disabled) return;

    const container = popup.querySelector('.variant-details');
    const items = [];
    container.querySelectorAll('.variant-option').forEach((opt) => {
      const qtySelector = opt.querySelector('.qty-selector');
      if (qtySelector && qtySelector.style.display !== 'none') {
        const input = qtySelector.querySelector('.qty-input');
        items.push({ id: Number(opt.dataset.id), quantity: parseInt(input.value || input.textContent) });
      }
    });

    if (items.length === 0) return;

    confirmBtn.disabled = true; 
    confirmBtn.textContent = 'Adding...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-ajax' })
    })
    .then(res => res.json())
    .then(data => {
      popup.style.display = 'none'; 

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
      document.dispatchEvent(new CustomEvent('cartOpen', { bubbles: true }));
      
      const drawer = document.querySelector('.site-header__cart-link, .js-drawer-open-cart, [data-drawer-open="cart"]');
      if (drawer) drawer.click();

      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Confirm'; 
      resetPopupState(popup); 

      setTimeout(() => {
          const drawerActive = document.querySelector('.js-drawer-open, .is-active, .cart-drawer--open');
          if (!drawerActive) {
            document.body.style.setProperty("overflow", "auto", "important");
            document.documentElement.style.setProperty("overflow", "auto", "important");
          }
      }, 300);
    })
    .catch(() => { 
      confirmBtn.disabled = false; 
      confirmBtn.textContent = 'Confirm'; 
      document.body.style.setProperty("overflow", "auto", "important");
    });
  }
}

// 4. Initialization
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.variant-option').forEach(function(variantBox) {
    if (variantBox.querySelector('.jtpl-category')) {
      variantBox.classList.add('has-best-offer');
    }
  });
  document.removeEventListener('click', handlePopupClicks);
  document.addEventListener('click', handlePopupClicks);
});

// Outside Click Fix
window.addEventListener('click', function (e) {
  if (e.target.classList.contains('variant-popup')) {
    e.stopPropagation(); // Stop reaching the drawer
    e.target.style.display = 'none';
    
    const drawerOpen = document.querySelector('.js-drawer-open, .is-active, .cart-drawer--open');
    if (!drawerOpen) {
      document.body.style.setProperty("overflow", "auto", "important");
    }
  }
});
/***************** End Cart Popup *****************/

